import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorMasterPostalcodeList = () => {
  const postalcodeList = useCallback((body, callback) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/master-postalcode/list', payload, response => {
      if (response.status_code === 200) {
        const { data } = response
        callback(data)
      }
    })
  }, [])

  return { postalcodeList }
}

export default InteractorMasterPostalcodeList
